import { IndexedDbConfig } from '@shared/indexed-db/constants/indexed-db.const';

export const INDEXED_DB_CONFIG = {
  TABLES: {
    CUSTOMS_COUNTRIES: 'customsCountries',
    MARINE_INSURANCE_COUNTRIES: 'marineInsuranceCountries',
    ISF_UNITS: 'isfUnits',
    INCOTERMS: 'incoterms',
    LINE_UNITS: 'lineUnits',
    SHIPMENT_UNITS: 'shipmentUnits',
    CURRENCIES: 'currencies',
    CURRENCIES_BY_DATE: 'currenciesByDate',
  },

  DATABASE_CONFIG: {
    databaseName: 'Eezyimport',
    databaseSchema: [
      {
        databaseVersion: 1,
        databaseSchemaChange: {
          customsCountries: '++id',
          marineInsuranceCountries: '++id',
          isfUnits: '++id',
          incoterms: '++id',
          lineUnits: '++id',
          shipmentUnits: '++id',
          currencies: '++id',
          currenciesByDate: '++id',
        },
      },
    ],
    foreignKeyErrors: false,
  } as IndexedDbConfig,
};
